import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

import { ReactComponent as AlertIcon } from "@src/assets/images/icons/alert.svg";
import { Link } from "react-router-dom";

export const CompleteProfileModal = ({
                                       completeProfileModal,
                                       setCompleteProfileModal,
                                   }) => {
    return (
        <div className="demo-inline-spacing ">
            <div className="vertically-centered-modal">
                <Modal
                    isOpen={completeProfileModal}
                    toggle={() => setCompleteProfileModal(!completeProfileModal)}
                    className="modal-dialog-centered"
                >
                    <ModalHeader
                        toggle={() => setCompleteProfileModal(!completeProfileModal)}
                    ></ModalHeader>
                    <ModalBody className={"text-center pt-0"}>
                        <div className={"d-flex flex-column align-items-center gap-2 mb-1"}>
                            <AlertIcon />
                            <h4 className={"text-center fw-bolder"}>Complete Your Profile</h4>
                        </div>
                        <h5 className={"text-secText mb-2"}>
                            You need to complete your profile before doing this action!
                        </h5>
                        <Button
                            block
                            color="dark"
                            tag={Link}
                            to="/profile"
                            className={
                                "d-flex align-items-center justify-content-center text-secText mb-1"
                            }
                        >
                            Go to Profile
                        </Button>{" "}
                        <Button
                            color="dark"
                            className={"mb-1"}
                            outline
                            onClick={() => setCompleteProfileModal(!completeProfileModal)}
                            block
                        >
                            Undo
                        </Button>
                    </ModalBody>
                </Modal>
            </div>
        </div>
    );
};
